module.exports = __webpack_public_path__ + "static/media/balduccis.741fa5d4.svg";